import React from "react";
import "./Countingsection.css";
import growthImg from '../Images/easytaxexperts1.jpg';
import successImg from '../Images/clients.png';
import hoursImg from '../Images/growth.png';
import professionalImg from '../Images/expert.png';
import { Link } from "react-router-dom";



import { 
  FaFileAlt, FaUniversity, FaBalanceScale, FaIdCard, 
  FaChartLine, FaGlobe, FaBook, FaUsersCog, FaShieldAlt,
  FaRocket, FaHandshake, FaPiggyBank, FaChartBar
} from 'react-icons/fa';

const Countingsection = () => {
  const stats = [
    { 
      image: growthImg, 
      number: "1,850+", 
      text: "Meticulously Prepared Tax Filings Completed Annually",
      description: "Each year, we successfully navigate complex tax scenarios for nearly two thousand clients, delivering optimized returns that maximize refund opportunities while ensuring full compliance with ever-evolving tax regulations. Our precision-focused approach identifies every eligible deduction and credit, transforming tax season from a stressful obligation into a strategic financial advantage."
    },
    { 
      image: successImg, 
      number: "3,200+", 
      text: "Thriving Clients Across Global Markets",
      description: "From ambitious startups in Silicon Valley to established enterprises in European markets and individual expatriates across Asia, our diverse client portfolio spans 28 countries. We've built lasting partnerships based on trust, exceptional service delivery, and measurable financial outcomes that empower businesses to scale and individuals to achieve their financial dreams with confidence and security."
    },
    { 
      image: hoursImg, 
      number: "22,500+", 
      text: "Productive Hours Reclaimed for Strategic Growth",
      description: "By handling complex financial tasks with expert efficiency, we've liberated over twenty-two thousand hours of valuable time that our clients have redirected toward business development, innovation, and personal growth initiatives. This time reclamation represents not just saved effort, but transformed opportunities for revenue generation and strategic advancement across multiple industries and personal financial goals."
    },
    { 
      image: professionalImg, 
      number: "15+", 
      text: "Years of Specialized Financial Expertise",
      description: "For more than a decade and a half, our team of certified professionals has been at the forefront of financial innovation, navigating multiple economic cycles, regulatory transformations, and technological revolutions. This extensive experience translates into proactive strategies that anticipate market shifts, optimize financial positioning, and deliver sustainable advantages in an increasingly complex global financial landscape."
    }
  ];

  const services = [
    { 
      name: "Comprehensive Amendment Filing Services", 
      icon: <FaFileAlt />, 
      description: "Transform past filing errors into future opportunities with our meticulous amendment filing process. We conduct thorough audits of previous returns, identify overlooked deductions and credits, and navigate the complex amendment procedures with both federal and state authorities.",
      features: ["Multi-year review capability", "IRS correspondence management", "State-level amendment coordination", "Refund optimization analysis"]
    },
    { 
      name: "Strategic Federal & State Tax Compliance", 
      icon: <FaUniversity />, 
      description: "Navigate the intricate web of federal and state tax obligations with confidence through our comprehensive compliance solutions. We maintain deep expertise across all 50 state jurisdictions and federal requirements.",
      features: ["Multi-state expertise", "Credit optimization", "Compliance monitoring", "Extension management"]
    },
    { 
      name: "Expert Tax Representation & Advocacy", 
      icon: <FaBalanceScale />, 
      description: "When facing IRS examinations, state audits, or complex tax controversies, our experienced representation team becomes your strategic shield. We handle all communications and negotiate favorable settlements.",
      features: ["Audit defense", "Collections negotiation", "Appeals representation", "Penalty abatement"]
    },
    { 
      name: "Streamlined ITIN Acquisition & Management", 
      icon: <FaIdCard />, 
      description: "Navigate the intricate ITIN application and renewal process with expert guidance that simplifies complex documentation requirements for foreign nationals and non-resident aliens.",
      features: ["Document certification", "Application tracking", "Renewal management", "Compliance verification"]
    },
    { 
      name: "Proactive Advanced Tax Strategy & Planning", 
      icon: <FaChartLine />, 
      description: "Transform tax planning from reactive compliance to strategic advantage with our forward-looking tax optimization services. We employ sophisticated forecasting models and scenario analysis.",
      features: ["Multi-year forecasting", "Scenario modeling", "Wealth preservation", "Strategic implementation"]
    },
    { 
      name: "Global Compliance: FBAR & FATCA Expertise", 
      icon: <FaGlobe />, 
      description: "Master the complexities of international financial reporting with our specialized FBAR and FATCA compliance solutions for clients with foreign assets across multiple jurisdictions.",
      features: ["Cross-border expertise", "Deadline management", "Penalty avoidance", "Asset structuring"]
    },
    { 
      name: "Precision Bookkeeping & Financial Intelligence", 
      icon: <FaBook />, 
      description: "Transform raw financial data into actionable business intelligence with our comprehensive bookkeeping and accounting services beyond basic record-keeping.",
      features: ["Real-time reporting", "Expense optimization", "Cash flow analysis", "Audit preparation"]
    },
    { 
      name: "Integrated Payroll & Human Capital Management", 
      icon: <FaUsersCog />, 
      description: "Streamline your most valuable asset management with our end-to-end payroll and human capital solutions for multiple employment classifications and state tax jurisdictions.",
      features: ["Multi-state payroll", "Tax filing", "Benefits administration", "Compliance reporting"]
    },
    { 
      name: "Business Formation & Entity Structuring", 
      icon: <FaRocket />, 
      description: "Launch your venture with optimal legal and tax foundations through our comprehensive business formation services analyzing ideal entity structures for liability protection and tax efficiency.",
      features: ["Entity selection", "Registration filing", "Operating agreements", "Tax elections"]
    },
    { 
      name: "Retirement & Estate Planning Integration", 
      icon: <FaPiggyBank />, 
      description: "Create comprehensive wealth transfer and retirement strategies that integrate seamlessly with your tax planning objectives for sustainable financial security across generations.",
      features: ["Retirement optimization", "Estate structuring", "Wealth transfer", "Tax minimization"]
    }
  ];

  return (
    <section className="countingsection-wrapper">
      {/* Stats Section */}
      <div className="stats-section">
        <div className="stats-header">
          <h2 className="stats-heading">
            Transforming Financial Complexity into <span className="highlight">Tangible Business Success</span>
          </h2>
          <p className="stats-subtext">
            For over fifteen years, we've been the strategic financial partner for thousands of businesses and individuals worldwide, 
            delivering not just compliance but competitive advantage through measurable results and optimized tax positions.
          </p>
        </div>

        <div className="stats-container">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className={`stat-item ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
            >
              <div className="stat-image-container">
                <img src={stat.image} alt={stat.text} className="stat-image" />
              </div>
              <div className="stat-content">
                <div className="stats-number">{stat.number}</div>
                <h3 className="stat-title">{stat.text}</h3>
                <p className="stat-description">{stat.description}</p>
                <div className="stat-impact">
                  <strong>Client Impact:</strong> {index === 0 ? "Average 27% higher refunds compared to self-filing" : 
                    index === 1 ? "92% client retention rate over 5+ years" :
                    index === 2 ? "Equivalent to 12 full-time employees' annual productivity" :
                    "Navigated 3 major tax law overhauls successfully"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Services Section */}
      <div className="services-section">
        <div className="services-header">
          <h2 className="services-title">Comprehensive Financial Solutions</h2>
          <p className="services-subtitle">
            Integrated financial ecosystems that synchronize tax strategy, compliance management, 
            and business optimization into a cohesive growth engine.
          </p>
          <div className="services-value-prop">
            <div className="value-item">
              <FaShieldAlt className="value-icon" />
              <span>Risk Mitigation & Compliance</span>
            </div>
            <div className="value-item">
              <FaChartBar className="value-icon" />
              <span>Strategic Optimization</span>
            </div>
            <div className="value-item">
              <FaHandshake className="value-icon" />
              <span>Partnership Approach</span>
            </div>
          </div>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-name">{service.name}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-features">
                <h4>Key Capabilities:</h4>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>Ready to Transform Your Financial Operations?</h3>
            <p>Schedule your comprehensive financial assessment today and discover measurable improvements to your bottom line.</p>
             <div className="cta-buttons">
              {/* Updated: Link to Contact Us page */}
              <Link to="/Contact" className="cta-btn primary">
                <span>Book Strategy Session</span>
                <FaChartLine className="btn-icon" />
              </Link>
              {/* Updated: Link to Services page */}
              <Link to="/Services" className="cta-btn secondary">
                <span>Catalogue of our services</span>
                <FaFileAlt className="btn-icon" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Countingsection;